import FilterValue from 'v2/querybuilder/types/filtervalue';
import { NormalisedFilter } from 'v2/querybuilder/types/querystore';

interface getFilterValueFromTypeParams {
  type: NormalisedFilter['value']['type'];
  value?: string | number | boolean | (string | number | boolean)[];
}

export function getFilterValueFromType(
  option: getFilterValueFromTypeParams,
): FilterValue {
  switch (option.type) {
    case 'string':
      return {
        type: option.type,
        value: option.value ? String(option.value) : undefined,
      };
    case 'number':
      return {
        type: option.type,
        value: option.value ? Number(option.value) : undefined,
      };
    case 'boolean':
      return {
        type: option.type,
        value: option.value ? Boolean(option.value) : undefined,
      };
    case 'string[]':
      return {
        type: option.type,
        values: Array.isArray(option.value)
          ? option.value.map((value) => ({
              type: 'string',
              value: String(value),
            }))
          : option.value
          ? [
              {
                type: 'string',
                value: String(option.value),
              },
            ]
          : [],
      };
    case 'number[]':
      return {
        type: option.type,
        values: Array.isArray(option.value)
          ? option.value.map((value) => ({
              type: 'number',
              value: Number(value),
            }))
          : option.value
          ? [{ type: 'number', value: Number(option.value) }]
          : [],
      };
    case 'boolean[]':
      return {
        type: option.type,
        values: Array.isArray(option.value)
          ? option.value.map((value) => ({
              type: 'boolean',
              value: Boolean(value),
            }))
          : option.value
          ? [{ type: 'boolean', value: Boolean(option.value) }]
          : [],
      };
    default:
      return {
        type: 'string',
        value: '',
      };
  }
}
